import { useEffect } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { SummaryTable } from 'modules/salary_advance/pages/SummaryPage/SummaryTable'

export default function SummaryPage() {
  useEffect(() => {
    track(trackingEvents.salaryAdvance.viewSummary)
  }, [])

  return (
    <ResponsivePage.Body variant="full">
      <SummaryTable />
    </ResponsivePage.Body>
  )
}
